import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles, ThemeProvider } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCar, faTruck, faTachometerAlt, faReply, faWalking, faBiking } from '@fortawesome/free-solid-svg-icons'
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FlagIcon from '@material-ui/icons/Flag';
import CircularProgress from '@material-ui/core/CircularProgress';

import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import format from "date-fns/format";
import Cookies from 'js-cookie';
import { clearCookie, setCookie } from '../../functions/Auth';
import API_PATH from "./../../constants/config.json";
const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  callBtn: {
    border: '1px solid #24618E',
    color: '#24618E',
    width: '100%',
    marginRight: '10px',
    textTransform: 'lowercase',
    lineHeight: 'normal',
    padding: '2px 5px',
    letterSpacing: '0',
    '@media only screen and (max-width: 3500px)': {
      marginBottom: '7px',
    },
    '@media only screen and (min-width: 3501px)': {
      marginBottom: '20px',
    },
    '& .MuiButton-root': {
      letterSpacing: '0',
    }
  },
  btnIcon: {
    marginRight: '6px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20px',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '35px',
    },
  },
  btnIconDate: {
    border: '1px solid #24618E',
    color: '#24618E',
    fontSize: '12px',
    width: '220px',
    marginRight: '10px',
    textTransform: 'lowercase',
    marginBottom: '10px',
    marginTop: '10px',
    padding: '5px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '& .MuiButton-root': {
      letterSpacing: '0',
    }
  },
  centerBtn: {
    textAlign: 'center',
    width: '100%',
    '@media only screen and (max-width: 3500px)': {
      marginTop: '15px',
      marginBottom: '5px',
    },
    '@media only screen and (min-width: 3501px)': {
      marginTop: '20px',
      marginBottom: '10px',
    },
  },
  clearBtn: {
    border: '1px solid #333',
    color: '#333',
    marginRight: '10px',
    textTransform: 'capitalize',
    padding: '3px 5px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '& .MuiButton-root': {
      letterSpacing: '0',
    },
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '250px',
    },
  },
  showBtn: {
    border: '1px solid #24618E',
    color: '#fff',
    background: '#24618E!important',
    marginRight: '10px',
    textTransform: 'capitalize',
    padding: '3px 10px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '250px',
    },
    '& .MuiButton-root': {
      letterSpacing: '0',
    },
    '& .MuiCircularProgress-root': {
      color: '#fff',
      '@media only screen and (max-width: 3500px)': {
        width: '25px !important',
        height: '25px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '40px !important',
        height: '40px !important',
      },
    }
  },
  showAllBtn: {
    border: '1px solid #24618E',
    color: '#fff',
    background: '#24618E!important',
    textTransform: 'capitalize',
    padding: '3px 10px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '@media only screen and (max-width: 3500px)': {
      width: '180px',
      marginBottom: "-10px"
    },
    '@media only screen and (min-width: 3501px)': {
      width: '300px',
      marginBottom: "0px",
      marginTop: '10px',
    },
    '& .MuiButton-root': {
      letterSpacing: '0',
    },
    '& .MuiCircularProgress-root': {
      color: '#fff',
      '@media only screen and (max-width: 3500px)': {
        width: '25px !important',
        height: '25px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '40px !important',
        height: '40px !important',
      },
    }
  },
  showBtnDes: {
    border: '1px solid #333',
    color: '#333',
    background: '#fff!important',
    marginRight: '10px',
    textTransform: 'capitalize',
    padding: '5px 10px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '& .MuiButton-root': {
      letterSpacing: '0',
    },
    '& .MuiCircularProgress-root': {
      color: '#24618E',
      '@media only screen and (max-width: 3500px)': {
        width: '25px !important',
        height: '25px !important',
      },
      '@media only screen and (min-width: 3501px)': {
        width: '40px !important',
        height: '40px !important',
      },
    },
    '@media only screen and (max-width: 3500px)': {
      width: '150px',
    },
    '@media only screen and (min-width: 3501px)': {
      width: '250px',
    },
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    height: '140',
    width: '100',
    boxShadow: 'none',
  },
  control: {
    padding: theme.spacing(2),
  },
  dateRange:
  {
    '& select': {
      width: '100%',
      fontSize: '15px',
      padding: '3px 5px',
      marginBottom: '0px',
    },
  },
  mainbtnDiv: {
    border: '1px solid #24618E',
    borderTop: 'none',
    borderRadius: '0px 0px 5px 5px',
    minHeight: '365px',
    '& .focusBtn': {
      color: "#fff",
      background: '#24618E',
    },
  },
  mainDateBox: {
    '& .MuiCollapse-wrapper': {
      marginLeft: '0px !important'
    },
    '& .MuiPickersBasePicker-pickerView': {
      display: 'inherit',
      maxWidth: '210px !important',
      minWidth: '210px !important',
      minHeight: '305px',
      overflowX: 'hidden',
      flexDirection: 'column',
      justifyContent: 'center',
      '& .MuiPickersMonthSelection-container': {
        minWidth: '210px !important',
        maxWidth: '210px !important',
        width: '210px !important',
      }
    },
    '& .MuiPickersYearSelection-container': {
      width: "210px !important",
    },
    '& .MuiInputLabel-formControl': {
      marginLeft: '9px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '28pt',
      },
    },
    '& .PrivateNotchedOutline-root-77': {
      padding: '7px !important'
    },
    '& .MuiOutlinedInput-input': {
      paddingRight: '5px',
      '@media only screen and (min-width: 3501px)': {
        fontSize: '22pt',
        padding: '30px 14px 18px !important'
      },
    },
    '@media only screen and (min-width: 3501px)': {
      marginBottom: '15px',
    },
  },
  fieldsetname: {
    width: 'auto',
    border: '1px solid rgba(0, 167, 93, 1)',
    margin: 'auto',
    padding: '10px',
    borderRadius: '5px',
    marginTop: "5px"
  },
  errMsgLogin: {
    '& span': {
      fontSize: '11pt !important'
    }
  },
  jnf: {
    border: "1px solid #cc9900",
    padding: '5px',
    margin: 0,
    borderRadius: '5px',
  },
  flagIcon: {
    marginTop: '0px',
    marginBottom: '-7px',
    marginRight: '10px',
    fontZize: '30px',
    color: "#cc9900"
  },
  dateBlock: {
    '& .MuiFormControl-root': {
      width: '100%',
    }
  },
  showAllNote: {
    textAlign: "center", margin: '0px',
    '@media only screen and (max-width: 3500px)': {
      fontSize: "18px",
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: "25pt",
      marginTop: '15px',
    },
  }
}));
//End Css code ...

const defaultMaterialTheme = createMuiTheme({
  palette: {
    primary: {
      main: "#24618E",
    },
    secondary: {
      main: "#24618E",
    },
  },
});

let prevStartDate = null;
let prevEndDate = null;

//Start System Layers component code ...
const SystemLayers = (props) => {
  const classes = useStyles();
  const [spacing, setSpacing] = React.useState(2);
  const [showBtn, setShowBtn] = React.useState(0);
  const [diffDate, setDiffDate] = React.useState(false);
  const [filterValue, setFilterValue] = React.useState(
    { volume_count: null },
    { vehicle_class: null },
    { traffic_speed: null },
    { turning_count: null },
    { pedestrian_count: null },
    { bicycle_count: null }
  );

  const [volume_count, setVolume_Count] = React.useState(false);
  const [traffic_speed, setTraffic_Speed] = React.useState(false);
  const [turning_count, setTurning_Count] = React.useState(false);
  const [pedestrian_count, setPedestrian_Count] = React.useState(false);
  const [bicycle_count, setBicycle_Count] = React.useState(false);
  const [vehicle_class, setVehicle_Class] = React.useState(false);

  const [newLoader, setNewLoader] = React.useState(false);
  const [dataError, setDataError] = React.useState(false);

  const [getSelectedStartDate, setSelectedStartDate] = React.useState(new Date());
  const [getSelectedEndDate, setSelectedEndDate] = React.useState(new Date());
  const [invalidDate, setInvalidDate] = React.useState(false);

  const [selectedType, setSelectedType] = React.useState([]);

  class LocalizedUtils extends DateFnsUtils {
    getDatePickerHeaderText(date) {
      return format(date, "YYYY-MM-DD");
    }
  }

  useEffect(() => {
    getInitialDates();
    setDataError(props.geojsonNF)
    if (props.geojsonNF) setShowBtn(1);
    if (!props.loaderOff) setShowBtn(1);

  }, [props.loaderOff, props.geojsonNF, props.checked]);

  //This method is use for get initial dates .... Start
  const getInitialDates = () => {
    if (!prevStartDate &&
      !prevEndDate) {
      let date = new Date();
      let endDate = new Date();
      let currentDate = new Date(date.getFullYear(), date.getMonth(), 1);
      setSelectedEndDate(endDate);
      let startyear = currentDate.getFullYear() - 5;
      currentDate.setFullYear(startyear);
      setSelectedStartDate(currentDate);
    } else {
      setSelectedEndDate(prevEndDate);
      setSelectedStartDate(prevStartDate);
    }
  }
  //This method is use for get initial dates .... End

  //This method is use for change start date .... Start
  const handleStartDateChange = (e) => {
    let date = new Date(e.getFullYear(), e.getMonth(), 1);
    setSelectedStartDate(date);
    prevStartDate = date;
    prevEndDate = getSelectedEndDate;
  }
  //This method is use for change start date .... End

  //This method is use for change end date .... Start
  const handleEndDateChange = (e) => {
    let currentMonth = new Date();
    let date = null;
    let datePickerVal = e;
    if (e.getMonth() !== (currentMonth.getMonth())) {
      date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth() + 1, 0);
    } else {
      if ((currentMonth.getFullYear() == datePickerVal.getFullYear())) {
        date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth(), currentMonth.getDate());
      } else {
        date = new Date(datePickerVal.getFullYear(), datePickerVal.getMonth() + 1, 0);
      }
    }
    setSelectedEndDate(date);
    prevEndDate = date;
    prevStartDate = getSelectedStartDate;
  }
  //This method is use for change end date .... End

  //This method is use for volume Count .... Start
  const volumeCount = () => {
    let volCount = volume_count;
    document.querySelector("#volume_count").classList.toggle("focusBtn");
    volCount = volCount ? false : true;
    setFilterValue({ ...filterValue, volume_count: volCount });
    let index = selectedType.indexOf('v');
    if (index > -1) {
      setSelectedType(selectedType.filter((value) => { return value !== 'v' }));
    } else {
      setSelectedType(
        [...selectedType, 'v']
      );
    }
    setVolume_Count((prev) => !prev);
    if (volCount == true || vehicle_class == true || traffic_speed == true || turning_count == true || pedestrian_count == true || bicycle_count == true) {
      setShowBtn(1);
      setNewLoader(true);
    }
    else {
      setShowBtn(0);
      setNewLoader(false);
    }
  }
  //This method is use for get volume Count .... End

  //This method is use for vehicle Class .... Start
  const vehicleClass = () => {
    let vehiClass = vehicle_class;
    document.querySelector("#vehicle_class").classList.toggle("focusBtn");
    vehiClass = vehiClass ? false : true;
    setFilterValue({ ...filterValue, vehicle_class: vehiClass });
    let index = selectedType.indexOf('c');
    if (index !== -1) {
      setSelectedType(selectedType.filter((value) => { return value !== 'c' }));
    } else {
      setSelectedType(
        [...selectedType, 'c']
      );
    }
    setVehicle_Class((prev) => !prev);
    if (volume_count == true || vehiClass == true || traffic_speed == true || turning_count == true || pedestrian_count == true || bicycle_count == true) {
      setShowBtn(1);
      setNewLoader(true);
    }
    else {
      setShowBtn(0);
      setNewLoader(false);
    }
  }
  //This method is use for vehicle Class .... End

  //This method is use for traffic Speed .... Start
  const trafficSpeed = () => {
    let traffSpeed = traffic_speed;
    document.querySelector("#traffic_speed").classList.toggle("focusBtn");
    traffSpeed = traffSpeed ? false : true;
    let index = selectedType.indexOf('s');
    if (index !== -1) {
      setSelectedType(selectedType.filter((value) => { return value !== 's' }));
    } else {
      setSelectedType(
        [...selectedType, 's']
      );
    }
    setFilterValue({ ...filterValue, traffic_speed: traffSpeed });
    setTraffic_Speed((prev) => !prev);
    if (volume_count == true || vehicle_class == true || traffSpeed == true || turning_count == true || pedestrian_count == true || bicycle_count == true) {
      setShowBtn(1);
      setNewLoader(true);
    }
    else {
      setShowBtn(0);
      setNewLoader(false);
    }
  }
  //This method is use for traffic Speed .... end
 
  //This method is use for get turning Count data.... start
  const turningCount = () => {
    let turnCount = turning_count;
    document.querySelector("#turning_count").classList.toggle("focusBtn");
    turnCount = turnCount ? false : true;
    let index = selectedType.indexOf('m');
    if (index !== -1) {
      setSelectedType(selectedType.filter((value) => { return value !== 'm' }));
    } else {
      setSelectedType(
        [...selectedType, 'm']
      );
    }
    setFilterValue({ ...filterValue, turning_count: turnCount });
    setTurning_Count((prev) => !prev);
    if (volume_count == true || vehicle_class == true || traffic_speed == true || turnCount == true || pedestrian_count == true || bicycle_count == true) {
      setShowBtn(1);
      setNewLoader(true);
    }
    else {
      setShowBtn(0);
      setNewLoader(false);
    }
  }
  //This method is use for get turning Count data.... end

  //This method is use for get pedestrian Count data .... start
  const pedestrianCount = () => {
    let pedesCount = pedestrian_count;
    document.querySelector("#pedestrian_count").classList.toggle("focusBtn");
    pedesCount = pedesCount ? false : true;
    let index = selectedType.indexOf('p');
    if (index !== -1) {
      setSelectedType(selectedType.filter((value) => { return value !== 'p' }));
    } else {
      setSelectedType(
        [...selectedType, 'p']
      );
    }
    setFilterValue({ ...filterValue, pedestrian_count: pedesCount });
    setPedestrian_Count((prev) => !prev);
    if (volume_count == true || vehicle_class == true || traffic_speed == true || turning_count == true || pedesCount == true || bicycle_count == true) {
      setShowBtn(1);
      setNewLoader(true);
    }
    else {
      setShowBtn(0);
      setNewLoader(false);
    }
  }
  //This method is use for get pedestrian Count data .... End

  //This method is use for get Bicycle Count data .... Start
  const bicycleCount = () => {
    let bicycCount = bicycle_count;
    document.querySelector("#bicycle_count").classList.toggle("focusBtn");
    bicycCount = bicycCount ? false : true;
    let index = selectedType.indexOf('b');
    if (index !== -1) {
      setSelectedType(selectedType.filter((value) => { return value !== 'b' }));
    } else {
      setSelectedType(
        [...selectedType, 'b']
      );
    }
    setFilterValue({ ...filterValue, bicycle_count: bicycCount });
    setBicycle_Count((prev) => !prev);
    if (volume_count == true || vehicle_class == true || traffic_speed == true || turning_count == true || pedestrian_count == true || bicycCount == true) {
      setShowBtn(1);
      setNewLoader(true);
    }
    else {
      setShowBtn(0);
      setNewLoader(false);
    }
  }
  //This method is use for get Bicycle Count data .... End

  const ShowAllStations = () => {    
    props.ShowAllStations();
    //clear filter stations
    clearFilter();
    //
  }

  //This method is use for show stations .... Start
  const ShowStations = () => {
    setDataError(false)
    let startDate = getSelectedStartDate.getFullYear() + '-' + (parseInt(getSelectedStartDate.getMonth()) + 1 > 9 ? parseInt(getSelectedStartDate.getMonth()) + 1 : ('0' + (parseInt(getSelectedStartDate.getMonth()) + 1))) + '-' + (parseInt(getSelectedStartDate.getDate()) > 9 ? parseInt(getSelectedStartDate.getDate()) : ('0' + (parseInt(getSelectedStartDate.getDate()))));

    let endDate = getSelectedEndDate.getFullYear() + '-' + (parseInt(getSelectedEndDate.getMonth()) + 1 > 9 ? parseInt(getSelectedEndDate.getMonth()) + 1 : '0' + (parseInt(getSelectedEndDate.getMonth()) + 1)) + '-' + (parseInt(getSelectedEndDate.getDate()) > 9 ? parseInt(getSelectedEndDate.getDate()) : ('0' + (parseInt(getSelectedEndDate.getDate()))));

    let currentMonth = parseInt(getSelectedStartDate.getMonth()) + 1 > 9 ? parseInt(getSelectedStartDate.getMonth()) + 1 : '0' + (parseInt(getSelectedStartDate.getMonth()) + 1);

    let endMonth = parseInt(getSelectedEndDate.getMonth()) + 1 > 9 ? parseInt(getSelectedEndDate.getMonth()) + 1 : '0' + (parseInt(getSelectedEndDate.getMonth()) + 1);

    let startYear = getSelectedStartDate.getFullYear();
    let endYear = getSelectedEndDate.getFullYear();

    if (startDate === endDate) {
      setDiffDate(true);
      setInvalidDate(false);
      return false;
    } else if ((currentMonth > endMonth && startYear > endYear) || startDate > endDate || startYear > endYear) {
      setDiffDate(false);
      setInvalidDate(true);
      return false;
    } else {
      setInvalidDate(false);
      setDiffDate(false);
    }

    let filterParams = {
      volume_count: volume_count,
      class_count: vehicle_class,
      speed_count: traffic_speed,
      turning_count: turning_count,
      pedestrian_count: pedestrian_count,
      bicycle_count: bicycle_count,
      selected_type: '{' + selectedType.toString() + '}',
      startDate: startDate,
      endDate: endDate
    };

    if(!Cookies.get('payload')) {
      clearCookie('activeSearchText');
      sessionStorage.removeItem('activeSearchResult');
      setCookie('activeSearchFilter', filterParams);
    }

    props.callSystemLayer(filterParams)

    props.loaderFunction();
    setShowBtn(0);
  }
  //This method is use for show stations .... End


  //This method is use for Clear .... Start
  const onClear = () => {
    setNewLoader(false);
    setShowBtn(0)
    setSelectedType([]);
    setFilterValue({});
    setDataError(false);
    setDiffDate(false);
    setInvalidDate(false);
    setVolume_Count(false);
    setVehicle_Class(false);
    setTraffic_Speed(false);
    setTurning_Count(false);
    setPedestrian_Count(false);
    setBicycle_Count(false);

    document.querySelector("#volume_count").classList.remove("focusBtn");
    document.querySelector("#vehicle_class").classList.remove("focusBtn");
    document.querySelector("#traffic_speed").classList.remove("focusBtn");
    document.querySelector("#turning_count").classList.remove("focusBtn");
    document.querySelector("#pedestrian_count").classList.remove("focusBtn");
    document.querySelector("#bicycle_count").classList.remove("focusBtn");
  }
  //This method is use for Clear .... End
  //method to clear filter
  const clearFilter = () => {    
    setShowBtn(0);
    setNewLoader(false);  
    setSelectedType([]);
    setFilterValue({});
    setVolume_Count(false);
    setVehicle_Class(false);
    setTraffic_Speed(false);
    setTurning_Count(false);
    setPedestrian_Count(false);
    setBicycle_Count(false);

    document.querySelector("#volume_count").classList.remove("focusBtn");
    document.querySelector("#vehicle_class").classList.remove("focusBtn");
    document.querySelector("#traffic_speed").classList.remove("focusBtn");
    document.querySelector("#turning_count").classList.remove("focusBtn");
    document.querySelector("#pedestrian_count").classList.remove("focusBtn");
    document.querySelector("#bicycle_count").classList.remove("focusBtn");
  }
  //end method filtering ... //
  return (
    <React.Fragment>
      <div className={classes.mainbtnDiv} style={{ padding: '10px', fontFamily: 'Avenir_light', }}>
        <Button variant="outlined" className={classes.showAllBtn} onClick={ShowAllStations}
          style={props.loadSource ? { left: "37%" } : { left: "37%", }}>
          {props.loadSource ? <CircularProgress /> : 'Show All Stations'
          }

        </Button>
        <hr style={{ borderTop: '1px solid rgba(0, 167, 93, 1)', marginTop: '20px', width: '90%' }} />
        <p className={classes.showAllNote}>Or show me any stations that have the following types of data</p>
        <Grid container className={classes.root} spacing={2}>
          <Grid item md={6} style={{ width: '50%' }}>
            <fieldset className={classes.fieldsetname}>
              <legend>Midblock data</legend>
              <Button onClick={volumeCount} variant="outlined" id="volume_count" className={classes.callBtn}>
                <FontAwesomeIcon icon={faCar} className={classes.btnIcon} />volume count
 </Button>
              <Button onClick={vehicleClass} variant="outlined" id="vehicle_class" className={classes.callBtn}>
                <FontAwesomeIcon icon={faTruck} className={classes.btnIcon} />vehicle class
 </Button>
              <Button onClick={trafficSpeed} variant="outlined" id="traffic_speed" className={classes.callBtn}>
                <FontAwesomeIcon icon={faTachometerAlt} className={classes.btnIcon} />traffic speed
 </Button>
            </fieldset>
          </Grid>
          <Grid item md={6} style={{ width: '50%' }}>
            <fieldset className={classes.fieldsetname}>
              <legend>Intersection data</legend>
              <Button onClick={turningCount} variant="outlined" id="turning_count" className={classes.callBtn}>
                <FontAwesomeIcon icon={faReply} className={classes.btnIcon} />turning count
 </Button>
              <Button onClick={pedestrianCount} variant="outlined" id="pedestrian_count" className={classes.callBtn}>
                <FontAwesomeIcon icon={faWalking} className={classes.btnIcon} />pedestrian count
 </Button>
              <Button onClick={bicycleCount} variant="outlined" id="bicycle_count" className={classes.callBtn}>
                <FontAwesomeIcon icon={faBiking} className={classes.btnIcon} />bicycle count
 </Button>
            </fieldset>
          </Grid>
        </Grid>

        <fieldset className={classes.fieldsetname}>
          <legend>During a time period</legend>
          <div className={classes.mainDateBox}>
            <div className={classes.dateRange}>
              <Grid container className={classes.root} spacing={2}>
                <Grid item xs={12}>
                  <Grid container justify="center" spacing={spacing}>
                    <Grid md={5} item>
                      <Paper className={classes.paper, classes.dateBlock} >
                        <ThemeProvider theme={defaultMaterialTheme}>
                          <MuiPickersUtilsProvider utils={LocalizedUtils}>
                            <DatePicker
                              className={classes.DPicker}
                              inputVariant="outlined"
                              variant="inline"
                              openTo="year"
                              views={["year", "month",]}
                              label="Start Date"
                              value={getSelectedStartDate}
                              maxDate={new Date()}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 51))}
                              onChange={handleStartDateChange}
                            />
                          </MuiPickersUtilsProvider>
                        </ThemeProvider>
                      </Paper>
                    </Grid>
                    <p style={{ margin: "auto" }}>and</p>
                    <Grid md={5} item>
                      <Paper className={classes.paper, classes.dateBlock}>
                        <ThemeProvider theme={defaultMaterialTheme}>
                          <MuiPickersUtilsProvider utils={LocalizedUtils}>
                            <DatePicker
                              className={classes.DPicker}
                              inputVariant="outlined"
                              variant="inline"
                              openTo="year"
                              views={["year", "month"]}
                              label="End Date"
                              value={getSelectedEndDate}
                              maxDate={new Date()}
                              minDate={new Date(new Date().setFullYear(new Date().getFullYear() - 51))}
                              onChange={handleEndDateChange}
                            />
                          </MuiPickersUtilsProvider>
                        </ThemeProvider>
                      </Paper>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </div>
          </div>
        </fieldset>
        <div className={classes.centerBtn}>
          <Button variant="outlined" id="clear_btn" className={classes.clearBtn} onClick={onClear}>
            Clear </Button>
          {
            (showBtn == 1 && newLoader) ?
              <Button variant="outlined" id="show_stations" onClick={ShowStations}
                className={classes.showBtn} >
                Show Stations
 </Button> :
              <Button variant="outlined" id="show_stations" className={classes.showBtnDes} disabled>
                {
                  props.loaderOff ?
                    <CircularProgress /> : 'Show Stations'
                }
              </Button>
          }
        </div>
        {
          dataError ?
            <p className={classes.jnf}>
              <FlagIcon className={classes.flagIcon} />
              There are no stations to display with that type of data </p> : null
        }
        {
          diffDate ?
            <p className={classes.jnf}>
              <FlagIcon className={classes.flagIcon} />
              Start date and end date should not be same ! </p> : null
        }
        {
          invalidDate ?
            <p className={classes.jnf}>
              <FlagIcon className={classes.flagIcon} />
              Invalid Date Selection ! </p> : null
        }
      </div>
    </React.Fragment>
  );
}
export default SystemLayers;

//End System Layers component code ...
